    <div class="container-fluid">
        <ngx-view-application></ngx-view-application>
        <ngx-third-party-application></ngx-third-party-application>
    

    </div>
